import React, { Component, Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Header from "../Header";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import { create } from "../../../services/guide";
import { catList } from "../../../services/course";
import AppContext from "../../../contexts/AppContext";

export class GuideCreate extends Component {
    state = {
        item: {   
            resource_type: 'internal',  
            category: '',      
            title : '',
            description : '',
            url: '',          
            image: '',
            color: '',                    
        },        
        errors: {},       
        categories: [],
        selectedcat : 'Select',
        selectedresource : 'Select',
        selectedFile : '', 
        resourceTypeList:[],  
        require_subscription: false    
    };
    
    listCats = (data) => {        
        let temp = this.state.item;
        let error = this.state.errors;
        temp.category = data[0].value;         
        this.state.selectedcat = data[0].name;  
        error.category = null;   
        this.setState({ item: temp, errors: error, categories: data });  
    }

    
    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;       
        let error = this.state.errors;
        error[field.target.name] = null;   
        this.setState({ item: temp, errors: error });
    };

    handleCheckBoxChange = e => {
        const toggled = this.state[e.target.id] === "true" ? "false" : "true";
        this.setState({ [e.target.id]: toggled });
    };

    handleBlur = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;
        if(field.target.name == 'payout')
        {
            this.state.item.payout = parseFloat(field.target.value).toFixed(2);
        }
        if(field.target.name == 'payout_plus')
        {
            this.state.item.payout_plus = parseFloat(field.target.value).toFixed(2);
        }
        let error = this.state.errors;
        error[field.target.name] = null;   
        this.setState({ item: temp, errors: error });
    };

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.description = value;

        let error = this.state.errors;
        error.description = null;

        this.setState({ item: temp, errors: error });
    };

    getExtension(filename) {
        let parts = filename.split('.');
        return parts[parts.length - 1];
    }

    isImage(filename) {
        let ext = this.getExtension(filename);
        switch (ext.toLowerCase()) {
          case 'jpg':
          case 'gif':
          case 'bmp':
          case 'png':
            //etc
            return true;
        }
        return false;
    }

    fileChangedHandler = (event) => {
        const file = event.target.files[0];
        this.setState({ selectedFile: file });
    }


    handlecatSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.category = selectedOption.value;
        let error = this.state.errors;
        error.category = null;   
        this.state.selectedcat = selectedOption.name;         
        this.setState({ item: temp, errors: error,selectedcat:selectedOption.name });
        //console.log(this.state.item,selectedOption.name);
    };

    handleReSourceSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.resource_type = selectedOption.value;       
        this.state.selectedresource = selectedOption.name; 
        let error = this.state.errors;
        error.resource_type = null;   
        this.setState({ item: temp, errors: error, selectedresource:selectedOption.name }); 
    }

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        let file = this.state.selectedFile;
        let FileSize = file.size / 1024 / 1024; // in MB
        let FileName = file.name;    
        let extensionLists = {}; //Create an object for all extension lists         
        extensionLists.image = ['jpg', 'gif', 'bmp', 'png'];

        // if(!fields.resource_type){
        //     formIsValid = false;
        //     errors.resource_type = "The type field is required.";
        // }        

        if(!fields.category){
            formIsValid = false;
            errors.category = "The category field is required.";
        }

        if(!fields.title){
            formIsValid = false;
            errors.title = "The title field is required.";
        }
        
        if(!fields.description){
            formIsValid = false;
            errors.description = "The description field is required.";
        }
                
        if (file && FileSize > 2) {
            errors.image = "File size exceeds 2 MB";
        } 
        
        if (file && !this.isImage(FileName)) {
            errors.image = "Please select a valid image file.";
        }
        
        if(fields.resource_type == 'external' && !fields.url){
            formIsValid = false;
            errors.url = "The source url field is required.";
        }
        if(fields.url && !(fields.url).match(/\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/g))
        {
            formIsValid = false;
            errors.url = "Please enter valid source url.";
        }

        if(!fields.color){
            formIsValid = false;
            errors.color = "The color field is required.";
        }
        
        this.setState({errors: errors});
        return formIsValid;
    }    

    handleSubmit = e => { 
        e.preventDefault();
        const formData = new FormData(e.target);       
        if(this.handleValidation()){  
            let errors = {};  
            if(this.state.selectedFile)
            {
                formData.append(
                    'image',
                    this.state.selectedFile,
                    this.state.selectedFile.name
                )
            }
            formData.append('resource_type',this.state.item.resource_type);
            formData.append('description',this.state.item.description);
            formData.append('category_id',this.state.item.category);
            formData.append('title',this.state.item.title);            
            formData.append('url',this.state.item.url);
            formData.append('color',this.state.item.color);
            formData.append('subscription',this.state.require_subscription);
            create(formData)
            .then(response => {
                this.props.history.push("/admin/guides");                
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });

            //console.log(formData.values(),this.state.item);
        }        
    };    

    componentDidMount() {          
        catList()
            .then(res => {
                this.setState({ categories: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

            this.setState({ resourceTypeList: [
                {"id":'external',"value":'external',"name":'External',"label":'External'},
                {"id":'internal',"value":'internal',"name":'Internal',"label":'Internal'},
                
            ] }); 
    }
    render() {
        return (
            <Fragment>
                <Header></Header>

                <div className="main-content mt-6">
                    <div className="container mt-3">
                        <div className="row justify-content-center">
                            <div
                                id="formModal"
                                className="col-12 col-lg-10 col-xl-8"
                            >
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h6 className="header-pretitle">
                                                    Add Guide
                                                </h6>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form data-select2-id="14" onSubmit={this.handleSubmit}>  
                                    {/* <div className="form-group">
                                        <label htmlFor="job_source">Type</label>
                                        <Select defaultValue={{ label: "Internal", value: "internal" }}
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="resource_type"
                                                id="resource_type"
                                                placeholder="Select"
                                                onChange={
                                                    this
                                                        .handleReSourceSelectChange
                                                }
                                                options={
                                                    this.state.resourceTypeList
                                                }
                                            ></Select>
                                        {this.state.errors.resource_type ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.resource_type}
                                            </div>
                                        ) : null}
                                        
                                    </div>   */}
                                <div className="form-group">
                                        <label htmlFor="category">Category</label>
                                        <Select 
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="category"
                                                id="category" 
                                                value={this.state.item.category}   
                                                placeholder = {this.state.selectedcat}                                            
                                                onChange={
                                                    this
                                                        .handlecatSelectChange
                                                }                                              
                                                options={
                                                    this.state.categories
                                                }
                                            ></Select>
                                        {this.state.errors.category ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.category}
                                            </div>
                                        ) : null}
                                      
                                    </div>                                
                                    <div className="form-group">
                                        <label htmlFor="title">Title</label>
                                        <input
                                            id="title"
                                            name="title"
                                            onChange={this.onChange}
                                            value={this.state.item.title || '' }
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.title ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.title}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-6">
                                        <label
                                            className="mb-1"
                                            htmlFor="description"
                                        >
                                            Description
                                        </label>
                                        
                                        <Quill
                                            style={{
                                                height: "200px"
                                            }}
                                            onChange={this.handleQuillChange}
                                            value={
                                                this.state.item
                                                    .description || ""
                                            }
                                        ></Quill>

                                        {this.state.errors.description ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.description}
                                            </div>
                                        ) : null}
                                    </div>  

                                    <div className="form-group">
                                            <label htmlFor="image">Image</label>
                                            <input
                                                        id="image"
                                                        name="image"                                           
                                                        onChange={this.fileChangedHandler}
                                                        type="file"
                                                        className="form-control"
                                                    />

                                                    {this.state.errors.image ? (
                                                        <div className="text-danger">
                                                            {this.state.errors.image}
                                                        </div>
                                                    ) : null}
                                            
                                        </div> 

                                        <div className="form-group">
                                            <label htmlFor="title">URL</label>
                                            <input
                                                id="url"
                                                name="url"
                                                onChange={this.onChange}
                                                value={this.state.item.url || '' }
                                                type="url"
                                                className="form-control"
                                                placeholder="https://www.placeholder.com/"
                                            />
                                            {this.state.errors.url ? (
                                                <div className="invalid-feedback">
                                                    {this.state.errors.url}
                                                </div>
                                            ) : null}
                                        </div> 

                                        <div className="form-group">
                                            <label htmlFor="color">Color</label>
                                            <input
                                                id="color"
                                                name="color"
                                                onChange={this.onChange}
                                                value={this.state.item.color || '' }
                                                type="text"
                                                className="form-control"
                                            />
                                            {this.state.errors.color ? (
                                                <div className="invalid-feedback">
                                                    {this.state.errors.color}
                                                </div>
                                            ) : null}
                                        </div> 

                                        <div className="form-group">
                                            {/* <label htmlFor="color">Requires subscription</label> */}
                                            
                                            <div className="custom-control custom-switch">
                                                        <input
                                                            onChange={
                                                                this
                                                                    .handleCheckBoxChange
                                                            }
                                                           
                                                            checked={
                                                                this.state
                                                                    .require_subscription ===
                                                                "true"
                                                            }
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="require_subscription"
                                                        />
                                                        <label
                                                            className="custom-control-label"
                                                            htmlFor="require_subscription"
                                                        >Requires subscription</label>
                                                    </div>
                                            {this.state.errors.color ? (
                                                <div className="invalid-feedback">
                                                    {this.state.errors.require_subscription}
                                                </div>
                                            ) : null}
                                        </div> 
                                       
                                    <hr className="mt-5 mb-5" />
                                    <button className="newJob btn btn-block btn-primary text-white">Publish Guide</button> 
                                    
                                    <div className=" btn-block center-text  mb-6 mt-3 d-flex justify-content-center">
                                        <Link
                                            to={`/admin/guides`}
                                            className="btn btn-link text-muted"
                                        >
                                            Cancel
                                        </Link>
                                       
                                    </div>
                                </form>    
                                                                 
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

GuideCreate.contextType = AppContext;
export default GuideCreate;



// WEBPACK FOOTER //
// ./src/components/admin/guides/Create.js